import {
  PButton,
  PCheckbox,
  PCheckboxProps,
} from '@porsche-design-system/components-react';
import { useEditorRef, usePluginOption } from 'platejs/react';
import { useState } from 'react';

import { ActionGroup } from '../ActionGroup';
import { Modal } from '../Modal';
import { DropPlugin } from './plugins/drop/plugin';
import { PastePlugin } from './plugins/paste';

export const UploadAccessibilityModal = ({
  heading,
  publicImageUploadText,
  uploadButtonText,
  resetButtonText,
}: {
  heading: string;
  publicImageUploadText: string;
  uploadButtonText: string;
  resetButtonText: string;
}) => {
  const editor = useEditorRef();

  const pendingDropCallback = usePluginOption(
    DropPlugin,
    'pendingUploadCallback',
  );
  const pendingPasteCallback = usePluginOption(
    PastePlugin,
    'pendingUploadCallback',
  );
  const pendingCallback = pendingDropCallback ?? pendingPasteCallback;

  const dropAllowPublicImageUpload = usePluginOption(
    DropPlugin,
    'allowPublicImageUpload',
  );
  const pasteAllowPublicImageUpload = usePluginOption(
    PastePlugin,
    'allowPublicImageUpload',
  );
  const allowPublicImageUpload = pendingDropCallback
    ? dropAllowPublicImageUpload
    : pasteAllowPublicImageUpload;
  const isRequired = allowPublicImageUpload === 'required';

  const [uploadAsPubliclyAccessible, setUploadAsPubliclyAccessible] =
    useState(false);

  const handleDismiss = () => {
    editor.setOption(DropPlugin, 'pendingUploadCallback', undefined);
    editor.setOption(PastePlugin, 'pendingUploadCallback', undefined);
    setUploadAsPubliclyAccessible(false);
  };

  const handleConfirm = () => {
    pendingCallback?.(isRequired || uploadAsPubliclyAccessible);
    editor.setOption(DropPlugin, 'pendingUploadCallback', undefined);
    editor.setOption(PastePlugin, 'pendingUploadCallback', undefined);
    setUploadAsPubliclyAccessible(false);
  };

  return (
    <Modal
      open={!!pendingCallback}
      onDismiss={handleDismiss}
      disableBackdropClick
    >
      <Modal.Header>{heading}</Modal.Header>

      <PCheckbox
        label={publicImageUploadText}
        checked={isRequired || uploadAsPubliclyAccessible}
        disabled={isRequired}
        onChange={(event) => {
          const { checked } = event.target as HTMLElement & PCheckboxProps;
          setUploadAsPubliclyAccessible(checked);
        }}
      />

      <ActionGroup>
        <PButton
          type="button"
          aria-label={resetButtonText}
          variant="secondary"
          icon="close"
          onClick={handleDismiss}
        >
          {resetButtonText}
        </PButton>
        <PButton
          type="button"
          aria-label={uploadButtonText}
          onClick={handleConfirm}
        >
          {uploadButtonText}
        </PButton>
      </ActionGroup>
    </Modal>
  );
};
